import { render, staticRenderFns } from "./Clerk.vue?vue&type=template&id=21f6dce1&scoped=true&"
import script from "./Clerk.vue?vue&type=script&lang=js&"
export * from "./Clerk.vue?vue&type=script&lang=js&"
import style0 from "./Clerk.vue?vue&type=style&index=0&id=21f6dce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6dce1",
  null
  
)

/* custom blocks */
import block0 from "./Clerk.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports